import styled from 'styled-components'
import { Fragment } from 'react'
import { Gif, Attribution } from '@giphy/react-giphy-brand'
import { fitGifToSize } from 'shared/util/sizing'
import GifMenu from 'shared/components/gif-menu/gif-menu'
import CaptionText from 'shared/components/story/caption'
import { grid9 } from 'shared/css/grid.css'

const GIF_WIDTH = parseInt(grid9)

const Container = styled.div`
    margin-bottom: 40px;
    width: ${grid9};
`

const Caption = styled.p`
    font-size: 18px;
    line-height: 1.4;
    margin: 0;
    padding: 16px 0;
`

const User = styled.div`
    background: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.3));
    bottom: 0;
    left: 0;
    padding: 10px;
    position: absolute;
    transform: translateY(100%);
    transition: transform 0.2s ease-out;
    width: 100%;
`

const Block = styled.div`
    margin-bottom: 20px;

    &:hover ${User} {
        transform: translateY(0);
    }
`

const showAttribution = ({ user, is_removed, is_private }) => user && !is_removed && !is_private

const StoryGifs = ({ cards = [], gifs = [] }) => (
    <Container>
        {cards.map(({ caption, gifId }, i) => {
            const gif = gifs[gifId]
            const { width, height } = fitGifToSize(gif, GIF_WIDTH, global.innerHeight * 0.8, 'contain')
            return (
                <Block key={`gif-${i}`}>
                    <Gif backgroundColor={'transparent'} gif={gif} width={width} height={height} showTags={false}>
                        <Fragment>
                            <GifMenu gif={gif} category="Story" />
                            {showAttribution(gif) ? (
                                <User>
                                    <Attribution user={gif.user} />
                                </User>
                            ) : null}
                        </Fragment>
                    </Gif>
                    {caption && (
                        <Caption>
                            <CaptionText caption={caption} />
                        </Caption>
                    )}
                </Block>
            )
        })}
    </Container>
)

export default StoryGifs
